import { render, staticRenderFns } from "./BuildingAndOwnerSelectModal.vue?vue&type=template&id=5a278f70&"
import script from "./BuildingAndOwnerSelectModal.vue?vue&type=script&lang=ts&"
export * from "./BuildingAndOwnerSelectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports